import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pushGlobalLoading, popGlobalLoading } from "../utils/progress";

/**
 * Top NProgress bar on SPA navigations (uses shared depth counter with axios + RQ).
 */
export function TopLoader() {
  const location = useLocation();

  useEffect(() => {
    pushGlobalLoading();
    let popped = false;
    const popOnce = () => {
      if (popped) return;
      popped = true;
      popGlobalLoading();
    };
    const id = window.setTimeout(popOnce, 180);
    return () => {
      window.clearTimeout(id);
      popOnce();
    };
  }, [location.pathname, location.search, location.key]);

  return null;
}

export default TopLoader;
